import * as React from 'react';
import { HotKeys } from 'ui/common/hotkeys';
import { FullscreenModalHeader } from 'ui';
import { keyCodeTypes } from 'ui/common/key-code-types';
import { CaseConnectionParam } from 'app/infrastructure/ui/form/types';
import { FixedDocument } from 'app/components/fixed-document';
import * as navigate from 'app/area/shared/navigation';
import { getLocationOfInitiator } from 'app/area/case/draft/connected-state';
import { BowtieTranslation } from '../constants';
import { getDraftId } from '../selectors';

import styles from './bowtie-overlay.scss';

interface BowtieOverlayProps {
  displayOverlay: boolean;
  caseNumber: number;
  connectedDrafts: CaseConnectionParam[];
  translation: BowtieTranslation;
  children?: React.ReactNode;
  className?: string;
}

export class BowtieOverlay extends React.Component<BowtieOverlayProps> {

  private keyMap: { [key: string]: string[] };
  private handlers: { [key: string]: () => void };

  constructor(props: BowtieOverlayProps) {
    super(props);

    this.keyMap = {
      closeOptions: [keyCodeTypes.Esc]
    };

    this.handlers = {
      closeOptions: this.onClose
    };
  }

  private onClose = () => {

    const { caseNumber, connectedDrafts } = this.props;

    if (connectedDrafts && connectedDrafts.length) {
      navigate.toConnectionInitiator(getLocationOfInitiator(connectedDrafts));
    } else {
      navigate.toCaseView(caseNumber);
    }
  };

  public render() {

    const { displayOverlay, connectedDrafts, translation, children, className } = this.props;

    if (!displayOverlay) {
      return children;
    }

    const draftId = getDraftId(connectedDrafts);
    const msg = draftId ? `${translation.bowtie_connect_cases} #${draftId}` : undefined;

    return <FixedDocument>
      <HotKeys keyMap={this.keyMap} handlers={this.handlers}>

        <div className={`${styles.fullscreen} ${className ? className : ''}`} >
          <FullscreenModalHeader onClose={this.onClose}>
            {msg}
          </FullscreenModalHeader>

          <div className={'container'} data-test-id="bowtie-overlay">
            <div className={styles.bowtieWrapper}>
              {children}
            </div>
          </div>

        </div>
      </HotKeys>
    </FixedDocument>;
  }
}
